import { DisplayValue } from '@adaptiva/core/common';
import { LoggingService } from '@adaptiva/core/logging';
import { BeforeSubmitFn, OverlayService } from '@adaptiva/core/overlays';
import { SnackbarService } from '@adaptiva/core/snackbars';
import { SummarizeService } from '@adaptiva/core/summary';
import { UiService } from '@adaptiva/core/ui';
import { EJavaClassNames, ObjectManagerService, SystemConfigService } from '@adaptiva/data-service';
import { CloudRelayServer } from '@adaptiva/operations-manager/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CloudRelayOverlay } from '../cloud-relay-overlay';

@Component({
	standalone: false,
	selector: 'app-cloud-relay-discovery-mode-action-overlay',
	templateUrl: './cloud-relay-discovery-mode-action-overlay.component.html',
	styles: [':host { display: block; height: 100%; }'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CloudRelayDiscoveryModeActionOverlayComponent extends CloudRelayOverlay implements OnInit {

	public readonly discoveryModeOptions: DisplayValue<CloudRelayServer.DiscoveryMode>[] = [
		new DisplayValue('Offline', CloudRelayServer.DiscoveryMode.OUT_OF_SERVICE),
		new DisplayValue('Test', CloudRelayServer.DiscoveryMode.TEST),
		new DisplayValue('Production', CloudRelayServer.DiscoveryMode.PROD)
	];

	public errors: Record<string, BehaviorSubject<string>> = {
		geolocation: new BehaviorSubject('')
	};

	protected readonly systemConfig: SystemConfigService = inject(SystemConfigService);
	
	constructor(
		protected objectManager: ObjectManagerService,
		protected summarizeService: SummarizeService,
		protected snackbarService: SnackbarService,
		_overlayService: OverlayService,
		_uiService: UiService,
		_logger: LoggingService
	) {
		super(_overlayService, _uiService, _logger, {
			title: 'Edit Discovery Mode'
		});
	}

	public override beforeSubmit: BeforeSubmitFn = (): boolean | Observable<boolean> => {
		if (!this.validate())
			return false;

		return this.objectManager.saveObject<CloudRelayServer>(
			EJavaClassNames.CloudRelayServer,
			this.context
		).pipe(
			map(() => {
				this.snackbarService.display('Successfully updated ' + this.context.name);
				return true;
			}),
			catchError((e: Error) => {
				const _message: string = this.logger.extractErrorMessage(e);

				this.logger.error('CloudRelayDiscoveryModeActionOverlayComponent.updateDiscoveryMode', _message)();
				this.overlayService.error('Encountered Errors', _message);

				return of(false);
			})
		);
	};

	protected override applyContext(_context: CloudRelayServer): void {
		super.applyContext(_context);
		this.context = this.summarizeService.generate<CloudRelayServer>(this.context.javaClassName, _context);
		this.title = `Edit ${this.context.name}`;
	}

	protected override validate(): boolean {
		const _error: string = this.getGeolocationError();

		this.errors.geolocation.next(_error);

		return !_error;
	}

}
